import React from 'react';

import { Slider } from '../../../WidgetConfiguratorComponents/FormGroups';

const min = 0;
const max = 90;
const marks = {
    0: 0,
    6: 6,
    18: 18,
    36: 36,
    54: 54,
    72: 72,
    90: 90,
};
const label = 'Percent label angle:';

export const PercentageLabelAngleSelector = (props) => {
    const { onChange, percentageLabelAngle } = props;

    return <Slider label={label} onChange={onChange} value={percentageLabelAngle} min={min} max={max} marks={marks} />;
};
